import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const CashTenureMigrationApi = createAsyncThunk(
  'CashTenureMigrationApi',
  async (cashTenureMigrationPayload, { dispatch }) => {
    dispatch({ type: 'CashTenureMigrationApi/pending', payload: {} });
    const {
      customerId,
      Authorization,
      customerRefNum,
      requestPayload,
      successFn,
      finallyFn,
    } = cashTenureMigrationPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'loanbooking3/cashtenuredatawithmigration',
      payload: requestPayload,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const tenureRes = res;
        // REMOVE THIS LINE
        console.log('=====response for casTenureMigrationApi=====', res);
        dispatch({
          type: 'CashTenureMigrationApi/fulfilled',
          payload: tenureRes,
        });
        successFn(res);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'CashTenureMigrationApi/rejected', payload: err });
        // REMOVE THIS LINE
        console.log('=====error response of casTenureMigrationApi=====', err);
      },
      finallyFn: () => {
        finallyFn();
      },
    });
  }
);

export const CashTenureMigrationApi_extrareducer = {
  [CashTenureMigrationApi.pending]: (state, action) => {
    state.cashTenureMigrationApiState.isLoading = true;
  },
  [CashTenureMigrationApi.fulfilled]: (state, action) => {
    state.cashTenureMigrationApiState.isLoading = false;
    state.cashTenureMigrationApiState.isSuccess = true;
    state.cashTenureMigrationApiState.isError = false;
    state.cashTenureMigrationApiState.response = action.payload;
  },
  [CashTenureMigrationApi.rejected]: (state, action) => {
    state.cashTenureMigrationApiState.isLoading = false;
    state.cashTenureMigrationApiState.isSuccess = false;
    state.cashTenureMigrationApiState.isError = true;
    state.cashTenureMigrationApiState.response = action.payload;
  },
};
